import { api } from '../https'
import type { SearchQueryParams } from '../types/servicesTypes/searchTypes'

export class SearchService {
  static async searchSuggest(term: string, abortSignal?: AbortSignal): Promise<string[]> {
    const res = await api.get<string[]>('/v3/search/suggest', {
      params: { term },
      signal: abortSignal,
    })
    // TODO temp solution -> refactor
    // there is nothing more constant than temporary... haha
    if (!res || res.status >= 400) {
      throw new Error('Something went wrong')
    }
    return res?.data
  }

  static async searchQuery<T>(
    { term, type = 'event', next, limit = 10 }: SearchQueryParams,
    tiles = false,
  ): Promise<PaginatedData<T>> {
    const params: SearchQueryParams = { term, type, limit }
    if (next) {
      params.next = next
    }
    const res = await api.get<PaginatedData<T>>(`/v3/search/query${tiles ? '/tiles' : ''}`, { params })
    // TODO temp solution -> refactor
    // there is nothing more constant than temporary... haha
    if (res.status >= 400) {
      throw new Error('Something went wrong')
    }
    return res?.data
  }
}
